export const setFlow = (state={}, action) => {
  switch (action.type) {
    case 'SET_FLOW':
      return action.flow;
    default:
      return state;
  }
}
